import { LookupItems } from '../../common/lookup-items.inteface';

export interface EvaluationsFilter {
  classId: number;
  sectionId: number;
  date?: string;
  sectionSubjectId?: number;
}
export interface Evaluations {
  evaluationId?: number;
  evaluationTypeId: number;
  evaluationCategories: number[];
  evaluationSubCategories: number[];
  evaluationActions: number[];
  classId: number;
  sectionId: number;
  sectionSubjectId?: number;
  points?: number;
  comment?: string;
  evaluationDate: string;
  evaluationFiles?: string[];
  students: string[];
}
export interface EvaluationStudents {
  evaluateCritiriaCount: number;
  imageUrl: string;
  name: string;
  nameEn: string;
  sectionName?: string;
  sectionNameEn?: string;
  className?: string;
  classNameEn?: string;
  studentId: string;
  colors?: string[];
}
export interface StudentEvaluations {
  evaluationId?: number;
  evaluationDate: string;
  teacherName: string;
  teacherNameEn: string;
  evaluationType: LookupItems;
  evaluationCategories: LookupItems[];
  evaluationSubcategories: LookupItems[];
  evaluationActions: LookupItems[];
  comment?: string;
  points?: number;
  evaluationStudents?: EvaluationStudents[]; // Only In List Mode In Evaluation Manage
}
export class EvaluationStatisticsFilter {
  classId: number;
  sectionId: number;
  subjectId: number;
  from?: string;
  to?: string;
  month?: string;
  year?: string;
}
